<template>
  <div style="margin-bottom:10px" v-if="onReady">
    <slot></slot>
    <div class="d-flex">
      <div
          v-if="showMultiSave"
          class="btn-group ml-1">
        <button
            :class="[btnClasses]"
            type="button"
            class="btn"
            @click.prevent="save(null)"
            style="border-right: 3px solid #ced4da !important;"
            :disabled="disableSaveButton">
          <i :class="[iconSave]"></i> {{ labelSave }}
        </button>
        <button :class="[btnClasses]" type="button" class="btn dropdown-toggle dropdown-toggle-split"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="disableSaveButton">
          <span class="sr-only">Toggle Dropdown</span>
        </button>
        <div class="dropdown-menu">
          <button class="dropdown-item" v-for="option in multiSaveOptions" @click.prevent="save(option)"
                  v-if="option.name" :disabled="disableSaveButton">
            {{ option.name }}
          </button>
        </div>
      </div>

      <button
          :class="[btnClasses]"
          v-if="showSave"
          type="button"
          class="btn ml-1"
          @click.prevent="save(null)"
          :disabled="disableSaveButton"
      >
        <i :class="[iconSave]"></i> {{ labelSave }}
      </button>

      <button
          v-if="showCancel"
          type="button"
          class="btn btn-danger ml-1"
          @click.prevent="cancel"
      >
        <i :class="[iconCancel]"></i> {{ labelCancel }}
      </button>

    </div>
  </div>

</template>

<script>
import onMountedDataProvider from '../../mixins/onMountedDataProvider';

export default {
  /**
   tag
   name: ks-data-navigation
   description: mode selector column component
   **/
  name: 'data-navigation-form',
  props: {
    dataProvider: {required: true},
    /* Configuration for Button Save */
    showSave: {type: Boolean, default: false},
    iconSave: {type: String, default: 'fas fa-save fa-fw icon'},
    labelSave: {type: String, default: "Save"},
    defaultDisableSave: {type: Boolean, default: false},
    /* Configuration for Button MultiSave */
    showMultiSave: {type: Boolean, default: false},
    multiSaveOptions: {type: Array, default: () => [{'name': 'Save'}]},
    /* Configuration for Button Cancel */
    showCancel: {type: Boolean, default: false},
    labelCancel: {type: String, default: "Cancel"},
    iconCancel: {type: String, default: 'fas fa-ban fa-fw icon'},
    DefaultDisableCancel: {type: Boolean, default: false},
    preventDefaultCancel: {type: Boolean, default: false},
    size: {
      type: String,
      default: null
    },
    round: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
  },
  mixins: [onMountedDataProvider],
  computed: {
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    btnClasses() {
      let size = `${this.size ? `btn-${this.size}` : ''}`;
      let shape = `${this.round ? ` round` : ''}`
      let color = ` btn-${this.color}`
      return size + shape + color;
    },
  },
  methods: {
    async cancel() {
      if (!this.preventDefaultCancel) {
        if (this.data_provider_ref.isLocalRecordNewRecord) {
          this.data_provider_ref.setLocalRecordToNewRecord();
        } else {
          this.data_provider_ref.setLocalRecord(this.data_provider_ref.l_originalRecord);
        }
      }
      this.$emit('onCancel');
    },

    async save(option = null) {
      try {
        this.disableSaveButton = true;
        if (option) {
          if (typeof option.disableSave != 'undefined' && option.disableSave) {
            this.$emit('onSave', {'type': null, 'data': null, 'option': option});
            return;
          }
        }
        let save = await this.data_provider_ref.upsertRecord();
        this.disableSaveButton = false;
        this.$emit('onSave', {...save, 'option': option});
      } catch (err) {
        console.log(err);
        this.disableSaveButton = false;
        this.$emit('onError', err);
      }
    }
  },

  async mounted() {
    await this.onMountedDataProvider();
  },

  data() {
    return {
      showMultiSaveOptions: false,
      page_size: 0,
      disableSaveButton: this.defaultDisableSave
    }
  }
}
</script>
